const faqSearchBar = document.querySelector('.faq-module .search-bar__form');
if (faqSearchBar) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const keyword = urlParams.get('keyword');
  faqSearchBar.querySelector('input').value = keyword;
}


const searchFaqPosts = (search) => {
  if (!search) {
      // eslint-disable-next-line no-param-reassign
      search = '';
  }
    axios
      .post(
        localData.siteURL,
        { action: 'searchFaqPosts', keyword: search.value, lang: localData.lang, id: localData.id },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((response) => {
        const resultBoxes = document.querySelector('.faq-module__list');
        resultBoxes.innerHTML = response.data.accordions;
        initAccordions();
        if (!response.data.accordions) {
          resultBoxes.innerHTML = response.data.no_results_text;
        }
      });
};

const searchFaq = document.querySelector('input#faq-bar-search');
if (searchFaq) {
  searchFaq.addEventListener(
    'keyup',
    debounce((e) => {
        if (e.key === 'Escape') {
            searchFaq.value = '';
        }
      searchFaqPosts(searchFaq);
    }, 400),
  );
}
